import { apiClient } from '../api/client';

export interface ValidateCouponRequest {
  code: string;
}

export interface ValidateCouponResponse {
  valid: boolean;
  discountAmount: number;
  coupon: {
    code: string;
    name: string;
    discountType: 'PERCENTAGE' | 'FIXED';
  };
}

/**
 * Cotação do carrinho calculada no servidor, em reais.
 *
 * É o mesmo cálculo que o pedido usa para cobrar. A vitrine mostra estes
 * valores e não refaz conta de desconto.
 */
export interface CartQuoteLine {
  productId: string;
  quantity: number;
  regularUnitPrice: number;
  unitPrice: number;
  promotional: boolean;
  total: number;
}

/** Algo no carrinho que impede o pedido, com a mensagem pronta. */
export interface CartQuoteProblem {
  code: 'MIN_QUANTITY_NOT_MET' | 'PURCHASE_LIMIT_REACHED' | 'PROMO_LIMIT_EXCEEDED';
  productId: string;
  message: string;
}

export interface CartQuote {
  lines: CartQuoteLine[];
  problems: CartQuoteProblem[];
  subtotal: number;
  itemDiscount: number;
  couponDiscount: number;
  discount: number;
  total: number;
  coupon: { code: string; name: string; discountType: 'PERCENTAGE' | 'FIXED' } | null;
}

/** Erro de cupom devolvido pelo servidor (422), com código estável. */
export function couponErrorFrom(error: any): { code: string; message: string } | null {
  const data = error?.response?.data;
  if (error?.response?.status === 422 && typeof data?.code === 'string' && data.code.startsWith('COUPON_')) {
    return { code: data.code, message: String(data.message ?? '') };
  }
  return null;
}

class CouponService {
  /** Cotação do carrinho do jogador, com o cupom informado (ou sem cupom). */
  async quote(storeId: string, couponCode: string | null): Promise<CartQuote> {
    return apiClient.post<CartQuote>(
      `/public/stores/${storeId}/cart/quote`,
      couponCode ? { couponCode } : {}
    );
  }

  /**
   * Validate a coupon code for the current cart
   */
  async validate(storeId: string, data: ValidateCouponRequest): Promise<ValidateCouponResponse> {
    return apiClient.post<ValidateCouponResponse>(
      `/public/stores/${storeId}/coupons/validate`,
      data
    );
  }
}

export const couponService = new CouponService();
